import { render, staticRenderFns } from "./RoleModule.vue?vue&type=template&id=30966a55&"
import script from "./RoleModule.vue?vue&type=script&lang=js&"
export * from "./RoleModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports